module.exports = __webpack_public_path__ + "img/10-min.847018a2.jpg";